//# sourceMappingURL=my-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-date.interface.js
// module id = 526
// module chunks = 3